"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// Utils
const generateColorFamily_1 = __importDefault(require("./src/utils/generateColorFamily"));
// Models
const colors_1 = __importDefault(require("./src/models/colors"));
const shadows_1 = __importDefault(require("./src/models/shadows"));
const spacing_1 = __importDefault(require("./src/models/spacing"));
const typography_1 = __importDefault(require("./src/models/typography"));
/**
 * Inicializador dos temas
 * @example
 * const service = new ProdigioTheme({ project: IProject, mainColors: IConstructorColors })
 */
class ProdigioTheme {
    constructor(data) {
        ProdigioTheme.project = data.project;
        ProdigioTheme.mainColors = data.mainColors;
    }
    get project() {
        return ProdigioTheme.project;
    }
    get colors() {
        const brand = this.generateColor(ProdigioTheme.mainColors.brand);
        const secondary = this.generateColor(ProdigioTheme.mainColors.secondary);
        const { base, danger, info, success, warning } = colors_1.default;
        return {
            base,
            black: '#000000',
            brand,
            secondary,
            system: {
                danger,
                info,
                success,
                warning
            },
            white: '#FFFFFF'
        };
    }
    get typography() {
        const { family, sizes } = typography_1.default;
        return {
            family,
            sizes
        };
    }
    get shadow() {
        return shadows_1.default;
    }
    get spacing() {
        return spacing_1.default;
    }
    generateColor(color) {
        return generateColorFamily_1.default(color);
    }
}
exports.default = ProdigioTheme;
